module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/tick green-7346d9d3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/tick green.svg
// module id = ./app/web/src/assets/tick green.svg
// module chunks = 0